<div class="flex-1 flex-col">
  <div class="details">
    <span>{{ review.created_at | i18n_date : 'd MMMM YYYY' | async }}</span>
    •
    <span>{{ review.job_title }}</span>
  </div>
  <div class="flex-row flex-1 justify-between items-center review-heading">
    <div class="flex-row flex-1 justify-start items-center">
      <mat-icon>person</mat-icon>
      <span>{{ 'review.heading' | translate : { isAuthor: isAuthor } }}</span>
    </div>
    @if (isAuthor) {
      <div class="flex-row flex-1 justify-end items-center">
        <button mat-icon-button (click)="editReview()">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button (click)="deleteReview()">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    }
  </div>
</div>

<app-review-rating [editable]="false" [value]="review.average_review_score"></app-review-rating>

<div class="review-content flex-col gap-4">
  <p>
    {{ review.review }}
  </p>
</div>

@if (review.recommendation) {
  <div class="review-content">
    <strong>{{ 'review_preview.tips.title' | translate }}</strong>
    <p>
      {{ review.recommendation }}
    </p>
  </div>
}

<div class="review-content">
  @if (review.comment && !commentFormControl) {
    <div class="review-comment flex-1 flex-col gap-2">
      <span class="comment-title">{{ 'review.doenkids_reaction' | translate }}</span>
      <p>{{ review.comment }}</p>
      <ng-container *ngTemplateOutlet="createCommentButton"></ng-container>
    </div>
  } @else {
    @if ((isAdmin$ | async) && !commentFormControl) {
      <div class="flex-row flex-1 justify-end">
        <button mat-icon-button (click)="startCommenting()">
          <mat-icon>{{ review.comment ? 'edit' : 'comment' }}</mat-icon>
        </button>
      </div>
    }
  }

  <ng-template #createCommentButton>
    @if ((isAdmin$ | async) && !commentFormControl) {
      <div class="flex-row flex-1 justify-end">
        <button mat-icon-button (click)="startCommenting()">
          <mat-icon>{{ review.comment ? 'edit' : 'comment' }}</mat-icon>
        </button>
      </div>
    }
  </ng-template>

  @if (commentFormControl) {
    <div class="review-comment flex-1 flex-col justify-start items-end gap-4">
      <ng-container *showSpinner="reviewCommentLoading$ | async">
        <textarea
          [maxlength]="maxChars"
          minlength="1"
          rows="7"
          matInput
          [formControl]="commentFormControl"
          [placeholder]="'review.comment.placeholder' | translate"
        ></textarea>
        <button mat-flat-button [disabled]="!commentFormControl.valid" (click)="saveReviewComment()">
          {{ 'review.comment.send' | translate }}
        </button>
      </ng-container>
    </div>
  }
</div>
